const isEnabled = (value: string | undefined): boolean =>
    value === 'true' ||
    process.env.VUE_APP_BASE_URL === 'http://localhost:8080';

const FLAGS = {
    chatbot: isEnabled(process.env.VUE_APP_FF_CHATBOT),
    chatbotQuota: isEnabled(process.env.VUE_APP_FF_CHATBOT_QUOTA),
};

export default FLAGS;
